function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Social_Twitter_ic"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 72.27,
  cy: 20.97,
  r: 16.97
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.22 148.27H16.73a12.72 12.72 0 01-12-16.84l27.54-78.84a12.73 12.73 0 0112-8.61h56.47a12.73 12.73 0 0112.05 8.64c6 17.58 19.55 56 27.21 78.84a12.72 12.72 0 01-12.07 16.76c-18.92 0-52.15 0-78.37.06z"
}));

var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 144.67 152.28",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgWeight;